import type {Money} from './Money';

export type VehiclePrice = {
  withoutVat: Money | null;
  withVat: Money | null;
  vatRate: string | null;
  vatCode?: string | null;
};
